import React from 'react';
import MasoryPost from './MasoryPost';
import NewPost from '../../containers/Post/NewPost/NewPost';
import StoriesBar from '../Stories/StoriesBar';
import { useSelector } from 'react-redux';
import localStorage from '../../utils/hooks/useLocalStorage';


const HomePost = ({ history }) => {
    const { userInfo } = useSelector(state => state.userInfo)

    
    let type = ""
    let _idEc = null

    if (userInfo.franchiseID) {
        if (userInfo.franchiseID.state ===2 &&  localStorage().getItem('typeProfile') !="user")  {
            _idEc = userInfo?.franchiseID?._id
        }
    }

    return (
        <>
            <div className='menu-center-home'>
                <NewPost type={type} _idEc={_idEc} />
                <MasoryPost history={history} />
            </div>

            <StoriesBar />
        </>
    )
}

export default HomePost


